import { render, staticRenderFns } from "./MenuLists.vue?vue&type=template&id=771a444f&scoped=true&"
import script from "./MenuLists.vue?vue&type=script&lang=js&"
export * from "./MenuLists.vue?vue&type=script&lang=js&"
import style0 from "./MenuLists.vue?vue&type=style&index=0&id=771a444f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771a444f",
  null
  
)

export default component.exports